import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { isPartialDate } from 'neuro-utils';
import * as React from 'react';
import { useIntl } from 'react-intl';

import { formatPartialDate } from 'Utility/date';
import { sortDocuments } from 'Utility/randomUtil';

const DiagnosticTestsDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  const sortedDocs = documents.toSorted((n1, n2) => sortDocuments([{ type: 'date', sortField: 'date' }])(n1, n2));

  return (
    <TileContentMaker
      type="recentList"
      data={sortedDocs.map(d => ({
        date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: fm(`polyneuroDiagnosticExams.` + d._type + 'Title'),
        key: d._id,
      }))}
    />
  );
};

interface IOwnProps {
  documents: (
    | IDocumentWithTypeV2<'csfExam'>
    | IDocumentWithTypeV2<'nerveBiopsy'>
    | IDocumentWithTypeV2<'skinBiopsy'>
  )[];
}

export default DiagnosticTestsDash;
